export const projectConstants = {
  title: 'Kenya Haemophilia Association',
  websiteLink: 'https://www.haemophilia-kenya.org',
  prefix: 'KHA',
  logo: 'KHA-logo.png',
  favicon: 'KHA-favicon.png',
  primaryColor: '#DC3933',
  secondaryColor: '#2E2E2E'
};
